import styled from "styled-components";
import Form from "react-bootstrap/Form";
import Col from "react-bootstrap/Col";

export const StyledForm = styled(Form)`
.col-form-label {
  font-size: 14px;
  font-weight: bold;
  text-align: center;
}

.labeltext svg {
  margin-right: 10px;
}
.inputsearch {
  input {
    border: 1px solid black !important;
    border-radius: 50px !important;
    padding: 7px 13px !important;
    font-size: 14px;
  }
  input::-webkit-input-placeholder {
    font-style: italic;
    font-weight: normal;
 }
 input:-moz-placeholder {
    font-style: italic;
    font-weight: normal;
 }
 input::-moz-placeholder {
    font-style: italic;
    font-weight: normal;
 }
 input:-ms-input-placeholder {
    font-style: italic;
    font-weight: normal;
 }
  #formPlaintextEmail{
    font-weight: bold;
  }
  label:after{
    color: red;
  }
  select {
    border: 1px solid black !important;
    border-radius: 30px !important;
    padding: 7px 13px !important;
    margin-bottom: 14px !important;
    font-size: 14px;
    background-image:linear-gradient(45deg, transparent 50%, #000 50%),
    linear-gradient(135deg, #000 50%, transparent 50%),
    linear-gradient(to right, #ccc, #ccc);
    background-position: calc(100% - 20px) calc(1em + 2px),
      calc(100% - 15px) calc(1em + 2px),
      calc(100% - 2.5em) 0.5em;
    background-size:
      5px 5px,
      5px 5px,
      1px 1.5em;
    background-repeat: no-repeat;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-appearance: none;
    -moz-appearance: none;
    &::-webkit-scrollbar{width:3px;border-left:1px solid #F72952;}
    &::-webkit-scrollbar-thumb{background-color:#F72952;}
  }
/*   button {
    background: transparent;
    border-radius: 100px;
    padding: 7px 24px;
    margin-right: 10px;
    border: 1px solid #E5E5E5;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-bottom: 13px;
    color: #000000;

    a { color : white}
    &:active {
      background: #354052 !important;
      border-color: #354052 !important;
      color: #fff
    }
    &:focus {
     background: #354052 !important;
      border-color: #354052 !important;
      color: #fff;
      outline: 0 !important;
    }
  } */
  .searchquery {
    padding: 5px 24px;
    font-size: 13px;
  }
  }
  .clean {
    border-radius: 100px;
    padding: 10px 24px;
    margin-right: 10px;
    border-color:#F72952 !important;
    background: #F72952 !important;
    font-size: 12px
  }
}
`;


export const FilterButton = styled.button`
  background: transparent;
  border-radius: 100px;
  padding: 7px 24px;
  margin-right: 10px;
  border: 1px solid #e5e5e5;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  margin-bottom: 13px;
  color: #000000;

  &:hover {
    background: #e5e5e5;
  }

  &.active {
    background: #354052 !important;
    border-color: #354052 !important;
    color: #fff !important;
  }
`;

export const StyledPaginator = styled(Col)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin: 70px 0px;

  .pagination {
    justify-content: center;
  }

  .pagination a {
    display: block;
    background-color: #e6ecf5;
    color: #9da9bd;
    border: none;
    border-radius: 5px;
    padding: 10px 20px;
    margin: 25px 6px;
    cursor: pointer;
    font-weight: bold;
  }

  .pagination .active a {
    background-color: #f72d54;
    color: white !important;
  }

  .pagination__link--disabled a {
    color: rgb(198, 197, 202);
  }

  @media (max-width: 767px) {
    display: none;
  }
`;
